import { constructAsync } from '../../../webmodule-common/other/async-constructor';
import { customElement, state } from 'lit/decorators.js';
import { disposeOf } from '../../../webmodule-common/other/dispose';
import { FranchiseeView } from '../../franchisee/view/franchisee-view';
import { html } from 'lit';
import { TabbedPageBase } from './helpers/page-base';
import { LangAppSettingsPage } from '../../../localization/scripts/dealer-franchisee/pages/app-settings-lang';
import { userDataStore } from '../common/current-user-data-store';

@customElement('app-settings')
export class AppSettings extends TabbedPageBase {
  @state()
  franchiseeView: FranchiseeView | null = null;

  constructor() {
    super();
  }

  /**
   * Staff Admin / support can open Settings with no usable branch so they can
   * reactivate a deactivated branch and recover from the no-branches page.
   */
  protected requiresAvailableBranches(): boolean {
    return !userDataStore.canChangeBranchHidden;
  }

  render() {
    if (!this.loggedIn) return html``;
    return html` <div class="page-content">
      <div class="page-container">${this.franchiseeView}</div>
    </div>`;
  }

  meta() {
    return {
      title: () => LangAppSettingsPage.franchiseeTitle(),
      description: LangAppSettingsPage.franchiseeSettingsPageDescription()
    };
  }

  protected async canLeavePage(): Promise<boolean> {
    if (this.franchiseeView) return await this.franchiseeView.canClose();
    else return true;
  }

  protected createRenderRoot(): HTMLElement | DocumentFragment {
    return this;
  }

  protected async franchiseeInformationFactory(): Promise<FranchiseeView> {
    return await constructAsync(new FranchiseeView());
  }

  async dispose() {
    await super.dispose();
    await disposeOf(this.franchiseeView);
    this.franchiseeView = null;
  }

  protected async setActiveTabByHash() {
    await this.franchiseeView?.setActiveTabByHash();
  }

  protected async afterUserConnected() {
    //we need to flush the user data store any time we come to this page in case it is stale information
    //switch to clear. this is causing problems in the main UI by leaving things in an unloaded state.
    await userDataStore.reLoadFranchisee();
    this.franchiseeView = await this.franchiseeInformationFactory();
    await super.afterUserConnected();
  }
}
